import { render, staticRenderFns } from "./AreaEmbargadaIbamaPoligonoPamgia.vue?vue&type=template&id=ad9848a4&lang=pug"
import script from "./AreaEmbargadaIbamaPoligonoPamgia.vue?vue&type=script&lang=js"
export * from "./AreaEmbargadaIbamaPoligonoPamgia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports